import React, { useEffect } from 'react';
import { Button, Drawer, Form, Space } from 'antd';
import { FormField } from '../../types';
import CustomForm from './CustomForm';
import SubmitButton from './SubmitButton';

interface FormDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  data: any;
  moduleName: string;
  setData: (data: any) => void;
  onFinish: (values: any) => void;
  formFields: FormField[];
  size?: 'default' | 'large' | undefined;
  /** Rendered under the form, e.g. an attachment list on an existing record. */
  children?: React.ReactNode;
}

const FormDrawer: React.FC<FormDrawerProps> = ({
  isOpen,
  onClose,
  data,
  moduleName,
  setData,
  onFinish,
  formFields,
  size = 'default',
  children,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (data != null) {
      const defaultValues: any = {};
      formFields.forEach((field) => {
        defaultValues[field.name] =
          field.defaultValue !== undefined
            ? field.defaultValue
            : data[field.name];
      });
      form.setFieldsValue(defaultValues);
    }
  }, [data]);

  const handleFormClose = () => {
    onClose();
    setData(null);
    form.resetFields();
  };

  const handleFinish = (values: any) => {
    onFinish(values);
    handleFormClose(); // Close the form after submission
  };

  return (
    <Drawer
      size={size}
      title={`${data != null ? 'Update' : 'Create'} ${moduleName}`}
      onClose={handleFormClose}
      open={isOpen}
      footer={
        <Space>
          <Button onClick={handleFormClose}>Cancel</Button>
          <SubmitButton form={form}>Submit</SubmitButton>
        </Space>
      }
    >
      <CustomForm
        rowCol={size === 'default' ? 1 : 2}
        data={data}
        form={form}
        formFields={formFields}
        onFinish={handleFinish}
        layout={'vertical'}
        formName={'form_drawer'}
      />
      {children}
    </Drawer>
  );
};

export default FormDrawer;
